
import { defineComponent, PropType } from 'vue'
import AsahiPopup from '@/components/library/AsahiPopUp.vue'

export default defineComponent({
  name: 'AsahiCustomButton',
  components: { AsahiPopup },
  data: () => ({
    openDropdown: false,
    input: '',
    notifications: { name: 'Notifications', label: 'Notifications', href: '/notifications', isActive: true }
  }),
  props: {
    dropdownName: String,
    options: {
      type: Array as PropType<Array<{ href: string }>>,
      default: () => []
    },
    popUpType: {
      type: String,
      default: 'pop-up'
    },
    customized: {
      type: Boolean,
      default: false
    },
    iconQuantity: Number,
    selected: Boolean
  },
  computed: {
    optionsWithNotifications () {
      const baseOptions = [...this.options]
      if (baseOptions.length === 4) {
        baseOptions.splice(3, 0, this.notifications)
      } if (baseOptions.length === 3) {
        baseOptions.splice(2, 0, this.notifications)
      }
      if (baseOptions.length === 2) {
        baseOptions.splice(1, 0, this.notifications)
      }

      return baseOptions
    }

  },
  methods: {
    toggleDropdown () {
      this.openDropdown = !this.openDropdown
    }

  }
})
